import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=16620820&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16620820"]])

export default __exports__